'use client';

const features = [
  {
    title: 'Tinh hoa trà Việt',
    description: 'Lựa chọn nguyên liệu cao cấp từ những vùng trà danh tiếng khắp Việt Nam.',
  },
  {
    title: 'Chất lượng từ nguồn',
    description: 'Sản phẩm được chế biến tỉ mỉ, chuẩn mực và an toàn cho sức khỏe.',
  },
  {
    title: 'Trải nghiệm thưởng trà',
    description: 'Mang đến không gian thư thái, phù hợp cho những ai yêu sự tinh tế và chậm rãi.',
  },
];

export default function AboutValues() {
  return (
    <section className="grid gap-6 md:grid-cols-3">
      {features.map(feature => (
        <div key={feature.title} className="rounded-[24px] border border-[#EDE6D8] bg-[#FCF7EE] p-5 shadow-[0_10px_30px_rgba(34,58,39,0.05)] md:rounded-[28px] md:p-6">
          <h3 className="mb-3 text-lg font-semibold text-[#223A27]">{feature.title}</h3>
          <p className="text-sm leading-7 text-[#5C5A52]">{feature.description}</p>
        </div>
      ))}
    </section>
  );
}
